import script from "./SlideOurService.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideOurService.vue?vue&type=script&setup=true&lang=js"

import "./SlideOurService.vue?vue&type=style&index=0&id=7dd7dbda&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd7dbda"]])

export default __exports__